exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\r\n\r\n\r\n.margin-buttom-10 {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.login-card {\r\n    padding: 30px;\r\n    border-radius: 3px;\r\n    color: rgba(0,0,0, 0.87);\r\n    background: #fff;\r\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n\r\n\r\n.margin-bottom-40 {\r\n    margin-bottom: 40px;\r\n}\r\n\r\n.landing-page-text {\r\n    font-size: 18px;\r\n    line-height: 25px;\r\n    font-weight: 200;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/pages/auth/error/error.component.css
// module id = 323
// module chunks = 3